import React, { useState } from "react";
import { Query } from "react-apollo";
import { FormattedMessage } from "react-intl";
import { Button } from "reactstrap";
import ProjectCard from "./components/ProjectCard";
import "./styles/projects-list.scss";
import { projectsQuery } from "./query";
import LoadingMessage from "utils/components/LoadingMessage";
import InfiniteScroll from "react-infinite-scroller";

const ProjectsList = ({ filters }) => {
  const [hasMore, setHasMore] = useState(true)

  const queryVariables = {
    ...filters,
    first: 10, // Default to 10 items per page
  }
  
  return (
    <div className="custom_class_project_list container py-3 px-0">
      <Query query={projectsQuery} variables={queryVariables}>
        {({ data, loading, error, fetchMore }) => {
          const promotedProjects = data?.promotedProjects?.edges || [];

          const loadMore = () => {
            if (!data?.promotedProjects?.pageInfo?.endCursor)return;

            if (!data?.promotedProjects?.pageInfo?.hasNextPage) {
              setHasMore(false);
            }

            fetchMore({
              variables: {
                afterCursor: data.promotedProjects.pageInfo.endCursor,
                first: 10
              },
              updateQuery: (prevResults, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prevResults;

                const newEdges = fetchMoreResult.promotedProjects.edges;
                const pageInfo = fetchMoreResult.promotedProjects.pageInfo;

                const mergedEdges = [
                  ...prevResults.promotedProjects.edges,
                  ...newEdges.filter(
                    (newEdge) =>
                      !prevResults.promotedProjects.edges.some(
                        (prevEdge) => prevEdge.node.id === newEdge.node.id
                      )
                  ),
                ];
                return newEdges.length
                  ? {
                      ...prevResults,
                      promotedProjects: {
                        ...fetchMoreResult.promotedProjects,
                        edges: mergedEdges,
                        ...pageInfo
                      },
                    }
                  : prevResults;
              },
            });
          }
  
          if (!data?.promotedProjects?.edges?.length && !loading && error)
            return (
              <p className="w-100 my-5 h4 text-danger text-center">
                <FormattedMessage
                  id="Projects.List.noData"
                  defaultMessage="We couldn't find any results for your search. 
                  Try exploring the categories below."
                />
              </p>
            );

          if (!loading && !data?.promotedProjects?.edges?.length)
            return (
              <p className="w-100 my-5 h4 text-danger text-center">
                <FormattedMessage
                  id="Projects.List.noDataFilter"
                  defaultMessage="No results. Try adjusting the filters."
                />
              </p>
            );{
          }
  
          return <>
            <InfiniteScroll
              className="col-12 d-flex flex-wrap overflow-hidden"
              loadMore={loadMore}
              hasMore={hasMore}
              loader={
                <div key="loader" className="text-center col-12 pt-3 pb-5">
                  <LoadingMessage />
                </div>
              }
            >
              {promotedProjects?.map((project, i) => (
                <ProjectCard
                    key={`item_${project.node.id}`}
                    islargeCard={i % 5 === 3}
                    {...project.node} />
              ))}
            </InfiniteScroll>
          </>
        }}
      </Query>
    </div>
  )
}

export default ProjectsList;
